// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSButton_button--default__Mvq_Z","icon-wrapper":"RSButton_icon-wrapper__YBal4","spin":"RSButton_spin__HBN29"};